"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSSR = void 0;
const isSSR = () => typeof window === 'undefined';
exports.isSSR = isSSR;
